export default "__VITE_ASSET__CQShbtat__"